import { render } from "./CompanyDocuments.vue?vue&type=template&id=23632550"
import script from "./CompanyDocuments.vue?vue&type=script&lang=js"
export * from "./CompanyDocuments.vue?vue&type=script&lang=js"

import "./CompanyDocuments.vue?vue&type=style&index=0&id=23632550&setup=true&lang=css"

import exportComponent from "C:\\creatorcube-vue3\\CreatorCUBE\\CreatorCUBE_Controller\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__